import React from 'react';
import { Icon } from './Icon.js';
export const IconDoubleChevronUp = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M20.5 11.5L12 3L3.5 11.5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M20.5 19.5L12 11L3.5 19.5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconDoubleChevronUp.js.map